export const BANK_NAMES = [
  {
    label: "ADITYA BIRLA FINANCE LIMITED",
    value: "ADITYA BIRLA FINANCE LIMITED",
  },
  {
    label: "ADITYA BIRLA HOUSING FINANCIAL LIMITED",
    value: "ADITYA BIRLA HOUSING FINANCIAL LIMITED",
  },
  { label: "AU HOUSING FINANCE LIMITED", value: "AU HOUSING FINANCE LIMITED" },
  { label: "AXIS BANK LTD", value: "AXIS BANK LTD" },
  { label: "BAJAJ FINANCE LIMITED", value: "BAJAJ FINANCE LIMITED" },
  { label: "CAPITAL FIRST LIMITED", value: "CAPITAL FIRST LIMITED" },
  {
    label: "CAPRI GLOBAL CAPITAL LIMITED",
    value: "CAPRI GLOBAL CAPITAL LIMITED",
  },
  { label: "CHOLAMANDALAM", value: "CHOLAMANDALAM" },
  { label: "CITI", value: "CITI" },
  { label: "CREDIT SUDHAR", value: "CREDIT SUDHAR" },
  { label: "DBS BANK INDIA LTD", value: "DBS BANK INDIA LTD" },
  { label: "DCB BANK", value: "DCB BANK" },
  { label: "DEUTSCHE BANK", value: "DEUTSCHE BANK" },
  { label: "DHFL", value: "DHFL" },
  { label: "EDELWEISS FINANCE LIMITED", value: "EDELWEISS FINANCE LIMITED" },
  { label: "ESSEL FINANCE", value: "ESSEL FINANCE" },
  {
    label: "FEDBANK FINANCIAL SERVICES LTD",
    value: "FEDBANK FINANCIAL SERVICES LTD",
  },
  {
    label: "FULLERTON INDIA CREDIT COMPANY LIMITED",
    value: "FULLERTON INDIA CREDIT COMPANY LIMITED",
  },
  { label: "HDB FINANCIAL SERVICES LTD", value: "HDB FINANCIAL SERVICES LTD" },
  { label: "HDFC BANK LTD", value: "HDFC BANK LTD" },
  { label: "HDFC LTD", value: "HDFC LTD" },
  { label: "HERO FIN CORP", value: "HERO FIN CORP" },
  { label: "HSBC Bank", value: "HSBC Bank" },
  { label: "ICICI BANK LIMITED", value: "ICICI BANK LIMITED" },
  { label: "IIFL", value: "IIFL" },
  {
    label: "INDIABULLS HOUSING FINANCE LIMITED",
    value: "INDIABULLS HOUSING FINANCE LIMITED",
  },
  {
    label: "INDOSTAR CAPITAL FINANCE LIMITED",
    value: "INDOSTAR CAPITAL FINANCE LIMITED",
  },
  { label: "INDUSIND BANK", value: "INDUSIND BANK" },
  {
    label: "Arohan Financial Services Ltd.",
    value: "Arohan Financial Services Ltd.",
  },
  {
    label: "KARVY FINANCIAL SERVICES PVT LTD",
    value: "KARVY FINANCIAL SERVICES PVT LTD",
  },
  { label: "KOTAK MAHINDRA BANK", value: "KOTAK MAHINDRA BANK" },
  { label: "KOTAK PRIME", value: "KOTAK PRIME" },
  { label: "L & T", value: "L & T" },
  { label: "LENDINGKART", value: "LENDINGKART" },
  {
    label: "M/S HINDUJA LEYLAND FINANCE LIMITED",
    value: "M/S HINDUJA LEYLAND FINANCE LIMITED",
  },
  { label: "MAGMA FINCORP LIMITED", value: "MAGMA FINCORP LIMITED" },
  {
    label: "MAGMA HOUSING FINANCE LIMITED",
    value: "MAGMA HOUSING FINANCE LIMITED",
  },
  { label: "NEOGROWTH CREDIT PVT LTD", value: "NEOGROWTH CREDIT PVT LTD" },
  {
    label: "ORIX LEASING & FINANCIAL SERVICES INDIA LIMITED",
    value: "ORIX LEASING & FINANCIAL SERVICES INDIA LIMITED",
  },
  { label: "PNB HOUSING FINANCE LTD", value: "PNB HOUSING FINANCE LTD" },
  { label: "RBL Bank Limited", value: "RBL Bank Limited" },
  {
    label: "RELIANCE COMMERCIAL FINANCE",
    value: "RELIANCE COMMERCIAL FINANCE",
  },
  { label: "RELIGARE FINVEST LIMITED", value: "RELIGARE FINVEST LIMITED" },
  {
    label: "RELIGARE HOUSING DEVELOPMENT FINANCE CORPORATION LIMITED",
    value: "RELIGARE HOUSING DEVELOPMENT FINANCE CORPORATION LIMITED",
  },
  { label: "SHRIRAM FINANCE", value: "SHRIRAM FINANCE" },
  {
    label: "SHRIRAM CITY UNION FINANCE LIMITED",
    value: "SHRIRAM CITY UNION FINANCE LIMITED",
  },
  { label: "STANDARD CHARTERED BANK", value: "STANDARD CHARTERED BANK" },
  {
    label: "TATA CAPITAL FINANCIAL SERVICES LIMITED",
    value: "TATA CAPITAL FINANCIAL SERVICES LIMITED",
  },
  { label: "UPF (Kapitaltech)", value: "UPF (Kapitaltech)" },
  { label: "YES BANK", value: "YES BANK" },
  { label: "Janlaxmi Finance", value: "Janlaxmi Finance" },
  {
    label: "UNITED INDIA INSURANCE CO LTD",
    value: "UNITED INDIA INSURANCE CO LTD",
  },
  { label: "OUTRIGHT", value: "OUTRIGHT" },
  { label: "CENTRAL BANK", value: "CENTRAL BANK" },
  {
    label: "TOYOTA FINANCIAL SERVICES INDIA LTD",
    value: "TOYOTA FINANCIAL SERVICES INDIA LTD",
  },
  {
    label: "HINDUJA LEYLAND FINANCE LIMITED",
    value: "HINDUJA LEYLAND FINANCE LIMITED",
  },
  {
    label: "RELIANCE HOUSING FINANCE LTD.",
    value: "RELIANCE HOUSING FINANCE LTD.",
  },
  { label: "TribeTech Private Ltd", value: "TribeTech Private Ltd" },
  { label: "CAPITAL FLOAT", value: "CAPITAL FLOAT" },
  { label: "VIJAYA BANK", value: "VIJAYA BANK" },
  {
    label: "ABHYUDAYA COOPERATIVE BANK LIMITED",
    value: "ABHYUDAYA COOPERATIVE BANK LIMITED",
  },
  { label: "ALLAHABAD BANK", value: "ALLAHABAD BANK" },
  { label: "ANDHRA BANK", value: "ANDHRA BANK" },
  { label: "BANK OF BARODA", value: "BANK OF BARODA" },
  { label: "BANK OF AMERICA", value: "BANK OF AMERICA" },
  { label: "BANK OF INDIA", value: "BANK OF INDIA" },
  { label: "BANK OF MAHARASHTRA", value: "BANK OF MAHARASHTRA" },
  { label: "BARCLAYS BANK", value: "BARCLAYS BANK" },
  { label: "CANARA BANK", value: "CANARA BANK" },
  { label: "CITY UNION BANK LIMITED", value: "CITY UNION BANK LIMITED" },
  { label: "CORPORATION BANK", value: "CORPORATION BANK" },
  { label: "DENA BANK", value: "DENA BANK" },
  { label: "DHANALAKSHMI BANK", value: "DHANALAKSHMI BANK" },
  {
    label: "DOMBIVLI NAGARI SAHAKARI BANK LIMITED",
    value: "DOMBIVLI NAGARI SAHAKARI BANK LIMITED",
  },
  { label: "FEDERAL BANK", value: "FEDERAL BANK" },
  { label: "IDBI BANK", value: "IDBI BANK" },
  { label: "INDIAN BANK", value: "INDIAN BANK" },
  { label: "INDIAN OVERSEAS BANK", value: "INDIAN OVERSEAS BANK" },
  {
    label: "JAMMU AND KASHMIR BANK LIMITED",
    value: "JAMMU AND KASHMIR BANK LIMITED",
  },
  {
    label: "JANAKALYAN SAHAKARI BANK LIMITED",
    value: "JANAKALYAN SAHAKARI BANK LIMITED",
  },
  {
    label: "JANATA SAHAKARI BANK LIMITED",
    value: "JANATA SAHAKARI BANK LIMITED",
  },
  { label: "KARNATAKA BANK LIMITED", value: "KARNATAKA BANK LIMITED" },
  { label: "LAXMI VILAS BANK", value: "LAXMI VILAS BANK" },
  { label: "MAHANAGAR COOPERATIVE BANK", value: "MAHANAGAR COOPERATIVE BANK" },
  {
    label: "NKGSB COOPERATIVE BANK LIMITED",
    value: "NKGSB COOPERATIVE BANK LIMITED",
  },
  { label: "ORIENTAL BANK OF COMMERCE", value: "ORIENTAL BANK OF COMMERCE" },
  {
    label: "PUNJAB AND MAHARSHTRA COOPERATIVE BANK",
    value: "PUNJAB AND MAHARSHTRA COOPERATIVE BANK",
  },
  { label: "PUNJAB AND SIND BANK", value: "PUNJAB AND SIND BANK" },
  { label: "PUNJAB NATIONAL BANK", value: "PUNJAB NATIONAL BANK" },
  {
    label: "SARASWAT COOPERATIVE BANK LIMITED",
    value: "SARASWAT COOPERATIVE BANK LIMITED",
  },
  {
    label: "SHIKSHAK SAHAKARI BANK LIMITED",
    value: "SHIKSHAK SAHAKARI BANK LIMITED",
  },
  {
    label: "STATE BANK OF BIKANER AND JAIPUR",
    value: "STATE BANK OF BIKANER AND JAIPUR",
  },
  { label: "STATE BANK OF HYDERABAD", value: "STATE BANK OF HYDERABAD" },
  { label: "STATE BANK OF INDIA", value: "STATE BANK OF INDIA" },
  { label: "STATE BANK OF MYSORE", value: "STATE BANK OF MYSORE" },
  { label: "STATE BANK OF PATIALA", value: "STATE BANK OF PATIALA" },
  { label: "STATE BANK OF TRAVANCORE", value: "STATE BANK OF TRAVANCORE" },
  { label: "SYNDICATE BANK", value: "SYNDICATE BANK" },
  {
    label: "TAMILNAD MERCANTILE BANK LIMITED",
    value: "TAMILNAD MERCANTILE BANK LIMITED",
  },
  { label: "UNION BANK OF INDIA", value: "UNION BANK OF INDIA" },
  { label: "UNITED BANK OF INDIA", value: "UNITED BANK OF INDIA" },
  {
    label: "UNITED OVERSEAS BANK LIMITED",
    value: "UNITED OVERSEAS BANK LIMITED",
  },
  { label: "RB [Advantage]", value: "RB [Advantage]" },
  {
    label: "EQUITAS SMALL FINANCE BANK LTD.",
    value: "EQUITAS SMALL FINANCE BANK LTD.",
  },
  {
    label: "Bee Fintech Private Limited (Incred Finance)",
    value: "Bee Fintech Private Limited (Incred Finance)",
  },
  { label: "FINMAX FINANCE", value: "FINMAX FINANCE" },
  { label: "MANNAPURAM FINANCE LIMITED", value: "MANNAPURAM FINANCE LIMITED" },
  {
    label: "EDELWEISS HOUSING FINANCE LIMITED",
    value: "EDELWEISS HOUSING FINANCE LIMITED",
  },
  { label: "CITI BANK", value: "CITI BANK" },
  {
    label: "Piramal Capital & Housing Finance Ltd.",
    value: "Piramal Capital & Housing Finance Ltd.",
  },
  { label: "IVL FINANCE LTD", value: "IVL FINANCE LTD" },
  {
    label: "INNOFIN SOLUTIONS PRIVATE LIMITED (LENDENCLUB)",
    value: "INNOFIN SOLUTIONS PRIVATE LIMITED (LENDENCLUB)",
  },
  { label: "EPIMONEY PRIVATE LIMITED", value: "EPIMONEY PRIVATE LIMITED" },
  { label: "Staragri Finance", value: "Staragri Finance" },
  { label: "GREENWOOD VENTURES", value: "GREENWOOD VENTURES" },
  {
    label: "Fullerton India Home Finance Company Ltd",
    value: "Fullerton India Home Finance Company Ltd",
  },
  {
    label: "DIGIKREDIT FINANCE PVT LTD (SME CORNER)",
    value: "DIGIKREDIT FINANCE PVT LTD (SME CORNER)",
  },
  { label: "DHANVARSHA FINVEST LTD", value: "DHANVARSHA FINVEST LTD" },
  { label: "AAVAS FINANCIERS LIMITED", value: "AAVAS FINANCIERS LIMITED" },
  {
    label: "CLIX CAPITAL SERVICES PVT LTD",
    value: "CLIX CAPITAL SERVICES PVT LTD",
  },
  {
    label: "ANDROMEDA SALES AND DISTRIBUTION PVT.LTD.",
    value: "ANDROMEDA SALES AND DISTRIBUTION PVT.LTD.",
  },
  {
    label: "BLUE JAY FINLEASE LIMITED (ZIPLOAN)",
    value: "BLUE JAY FINLEASE LIMITED (ZIPLOAN)",
  },
  { label: "Finsol Marketing Pvt. Ltd", value: "Finsol Marketing Pvt. Ltd" },
  {
    label: "FINWIZZ MANAGEMENT CONSULTANTS PVT LTD",
    value: "FINWIZZ MANAGEMENT CONSULTANTS PVT LTD",
  },
  { label: "ECL Finance Limited", value: "ECL Finance Limited" },
  {
    label: "Future Generali India Insurance Company Ltd",
    value: "Future Generali India Insurance Company Ltd",
  },
  {
    label: "Vastu Housing Finance Corporation Limited",
    value: "Vastu Housing Finance Corporation Limited",
  },
  {
    label: "ICICI Prudential Life Insurance Company Ltd",
    value: "ICICI Prudential Life Insurance Company Ltd",
  },
  {
    label: "CignaTTK Health Insurance Company Limited",
    value: "CignaTTK Health Insurance Company Limited",
  },
  {
    label: "Liberty General Insurance Limited",
    value: "Liberty General Insurance Limited",
  },
  {
    label: "VISTAAR FINANCIAL SERVICES PVT LTD",
    value: "VISTAAR FINANCIAL SERVICES PVT LTD",
  },
  { label: "PAYSENSE", value: "PAYSENSE" },
  {
    label: "JRG FINCORP LTD (INDITRADE)",
    value: "JRG FINCORP LTD (INDITRADE)",
  },
  { label: "AMBIT FINVEST PVT LTD", value: "AMBIT FINVEST PVT LTD" },
  { label: "COINTRIBE", value: "COINTRIBE" },
  {
    label: "ANAND RATHI GLOBAL FINANCE LIMITED",
    value: "ANAND RATHI GLOBAL FINANCE LIMITED",
  },
  {
    label: "COINTRIBE TECHNOLOGY PRIVATE LIMITED",
    value: "COINTRIBE TECHNOLOGY PRIVATE LIMITED",
  },
  { label: "HINDUJA HOUSING FINANCE", value: "HINDUJA HOUSING FINANCE" },
  {
    label: "PROFECTUS CAPITAL PRIVATE LIMITED",
    value: "PROFECTUS CAPITAL PRIVATE LIMITED",
  },
  { label: "RATTANINDIA FINANCE", value: "RATTANINDIA FINANCE" },
  { label: "NIYOGIN FINTECH LIMITED", value: "NIYOGIN FINTECH LIMITED" },
  {
    label: "POONAWALLA FINANCE PRIVATE LIMITED",
    value: "POONAWALLA FINANCE PRIVATE LIMITED",
  },
  { label: "CASHE BANK", value: "CASHE BANK" },
  { label: "KUBIZ CAPITAL PVT LTD", value: "KUBIZ CAPITAL PVT LTD" },
  {
    label: "SUSTAINABLE AGRO-COMMERCIAL FINANCE LTD",
    value: "SUSTAINABLE AGRO-COMMERCIAL FINANCE LTD",
  },
  {
    label: "CLIX HOUSING FINANCE PVT LTD",
    value: "CLIX HOUSING FINANCE PVT LTD",
  },
  {
    label: "LIC HOUSING FINANCE LIMITED",
    value: "LIC HOUSING FINANCE LIMITED",
  },
  {
    label: "ADHAR HOUSING FINANCE LIMITED",
    value: "ADHAR HOUSING FINANCE LIMITED",
  },
  {
    label: "RETRA VENTURES PRIVATE LIMITED",
    value: "RETRA VENTURES PRIVATE LIMITED",
  },
  { label: "IDFC FIRST BANK", value: "IDFC FIRST BANK" },
  {
    label: "INDIABULLS COMMERCIAL CREDIT LIMITED",
    value: "INDIABULLS COMMERCIAL CREDIT LIMITED",
  },
  {
    label: "INDIABULLS RURAL FINANCE PRIVATE LIMITED",
    value: "INDIABULLS RURAL FINANCE PRIVATE LIMITED",
  },
  { label: "IIFL HOME FINANCE LTD", value: "IIFL HOME FINANCE LTD" },
  {
    label: "TVS CREDIT SERVICES LIMITED",
    value: "TVS CREDIT SERVICES LIMITED",
  },
  { label: "KARUR VYSYA BANK", value: "KARUR VYSYA BANK" },
  { label: "HERO HOUSING FINANCE LTD", value: "HERO HOUSING FINANCE LTD" },
  {
    label: "OXYZO FINANCIAL SERVICES PRIVATE LIMITED",
    value: "OXYZO FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "FINBUCKET TECHNOLOGIES PVT LTD",
    value: "FINBUCKET TECHNOLOGIES PVT LTD",
  },
  {
    label: "NDX P2P Private Limited Liquiloans",
    value: "NDX P2P Private Limited Liquiloans",
  },
  {
    label: "NOMISMA MOBILE SOLUTIONS PRIVATE LIMITED",
    value: "NOMISMA MOBILE SOLUTIONS PRIVATE LIMITED",
  },
  { label: "FEDFINA", value: "FEDFINA" },
  { label: "JAIN SONS FINLEASE LIMITED", value: "JAIN SONS FINLEASE LIMITED" },
  { label: "UGRO CAPITAL LIMITED", value: "UGRO CAPITAL LIMITED" },
  { label: "MUTHOOT FINCORP LTD", value: "MUTHOOT FINCORP LTD" },
  {
    label: "SHRIRAM HOUSING FINANCE LIMITED",
    value: "SHRIRAM HOUSING FINANCE LIMITED",
  },
  { label: "SHUBHAM HOUSING FINANCE", value: "SHUBHAM HOUSING FINANCE" },
  { label: "PODS VENTURES", value: "PODS VENTURES" },
  { label: "RAAJ KHOSLA & CO PVT LTD", value: "RAAJ KHOSLA & CO PVT LTD" },
  { label: "SHINHAN BANK", value: "SHINHAN BANK" },
  { label: "AXIS FINANCE LIMITED", value: "AXIS FINANCE LIMITED" },
  {
    label: "BRIDGE FINTECH SOLUTIONS PRIVATE LIMITED",
    value: "BRIDGE FINTECH SOLUTIONS PRIVATE LIMITED",
  },
  {
    label: "CENTRUM HOUSING FINANCE LIMITED",
    value: "CENTRUM HOUSING FINANCE LIMITED",
  },
  { label: "FINTREE FINANCE PVT LTD", value: "FINTREE FINANCE PVT LTD" },
  { label: "Ashv Finance Limited", value: "Ashv Finance Limited" },
  {
    label: "AU SMALL FINANCE BANK LIMITED",
    value: "AU SMALL FINANCE BANK LIMITED",
  },
  {
    label: "HIVELOOP CAPITAL PRIVATE LIMITE (UDAAN CAPITAL)",
    value: "HIVELOOP CAPITAL PRIVATE LIMITE (UDAAN CAPITAL)",
  },
  {
    label: "EDELWEISS RETAIL FINANCE LIMITED",
    value: "EDELWEISS RETAIL FINANCE LIMITED",
  },
  { label: "FINNABLE CREDIT PVT LTD", value: "FINNABLE CREDIT PVT LTD" },
  {
    label: "INDUSAGE TECHAPP PRIVATE LIMITED",
    value: "INDUSAGE TECHAPP PRIVATE LIMITED",
  },
  {
    label: "BAJAJ HOUSING FINANCE LIMITED",
    value: "BAJAJ HOUSING FINANCE LIMITED",
  },
  { label: "IIFL FINANCE LTD", value: "IIFL FINANCE LTD" },
  { label: "LEONARD FINANCE", value: "LEONARD FINANCE" },
  {
    label: "GROWTH SOURCE FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
    value: "GROWTH SOURCE FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
  },
  {
    label: "LEONARD FINANCE PRIVATE LIMITED",
    value: "LEONARD FINANCE PRIVATE LIMITED",
  },
  {
    label: "MAS Financial Services Limited",
    value: "MAS Financial Services Limited",
  },
  {
    label: "JANA SMALL FINANCE BANK LTD",
    value: "JANA SMALL FINANCE BANK LTD",
  },
  {
    label: "CapFloat Financial Services Private Limited",
    value: "CapFloat Financial Services Private Limited",
  },
  {
    label: "DAVINTA FINANCIAL SERVICES PRIVATE LIMITED",
    value: "DAVINTA FINANCIAL SERVICES PRIVATE LIMITED",
  },
  { label: "LIQUI LOANS", value: "LIQUI LOANS" },
  { label: "Fortune Credit Capital Ltd", value: "Fortune Credit Capital Ltd" },
  { label: "GODREJ HOUSING FINANCE", value: "GODREJ HOUSING FINANCE" },
  {
    label: "UPWARD FINTECH SERVICES PRIVATE LIMITED",
    value: "UPWARD FINTECH SERVICES PRIVATE LIMITED",
  },
  {
    label: "HDFC CREDILA FINANCIAL SERVICES LIMITED",
    value: "HDFC CREDILA FINANCIAL SERVICES LIMITED",
  },
  {
    label: "SSA FINSERV PRIVATE LIMITED",
    value: "SSA FINSERV PRIVATE LIMITED",
  },
  { label: "Poonawalla Fincorp Limited", value: "Poonawalla Fincorp Limited" },
  {
    label: "RUPEEK FINTECH PRIVATE LIMITED",
    value: "RUPEEK FINTECH PRIVATE LIMITED",
  },
  {
    label: "MINIONS VENTURES PVT LTD (KREDX)",
    value: "MINIONS VENTURES PVT LTD (KREDX)",
  },
  {
    label: "ASHE MARCOM PRIVATE LIMITED",
    value: "ASHE MARCOM PRIVATE LIMITED",
  },
  { label: "BAJAJ FINSERV DIRECT LTD", value: "BAJAJ FINSERV DIRECT LTD" },
  {
    label: "KISETSU SAISON FINANCE (INDIA) PVT LTD (CREDITSAISON)",
    value: "KISETSU SAISON FINANCE (INDIA) PVT LTD (CREDITSAISON)",
  },
  {
    label: "CHOLAMANDALAM INVESTMENT & FINANCE CO LTD",
    value: "CHOLAMANDALAM INVESTMENT & FINANCE CO LTD",
  },
  {
    label: "GREENIZON AGRITECH CONSULTANCY PRIVATE LIMITED (JAI KISAN)",
    value: "GREENIZON AGRITECH CONSULTANCY PRIVATE LIMITED (JAI KISAN)",
  },
  { label: "TEZZRACT FINTECH PVT LTD", value: "TEZZRACT FINTECH PVT LTD" },
  {
    label: "KKR India Financial Services Limited (Incred)",
    value: "KKR India Financial Services Limited (Incred)",
  },
  { label: "Protium Finance Limited", value: "Protium Finance Limited" },
  {
    label: "MINIOS VENTURES PVT LTD (KREDEX)",
    value: "MINIOS VENTURES PVT LTD (KREDEX)",
  },
  { label: "GODREJ FINANCE LIMITED", value: "GODREJ FINANCE LIMITED" },
  {
    label: "FINPLEX TECHNOLOGIES PRIVATE LIMITED",
    value: "FINPLEX TECHNOLOGIES PRIVATE LIMITED",
  },
  {
    label: "Unity Small Finance Bank Limited",
    value: "Unity Small Finance Bank Limited",
  },
  {
    label: "ICICI HOME FINANCE COMPANY LIMITED",
    value: "ICICI HOME FINANCE COMPANY LIMITED",
  },
  {
    label: "Mahindra Rural Housing Finance Limited",
    value: "Mahindra Rural Housing Finance Limited",
  },
  { label: "SURYODAYA BANK", value: "SURYODAYA BANK" },
  {
    label: "INDIFI TECHNOLOGIES PRIVATE LIMITED",
    value: "INDIFI TECHNOLOGIES PRIVATE LIMITED",
  },
  { label: "POONAWALLA HOUSING LIMITED", value: "POONAWALLA HOUSING LIMITED" },
  { label: "AVANSE FINANCIAL SERVICES", value: "AVANSE FINANCIAL SERVICES" },
  { label: "TATA BUSINESS HUB LIMITED", value: "TATA BUSINESS HUB LIMITED" },
  {
    label: "MYLOANCARE VENTURES PRIVATE LIMITED (MONEYWIDE)",
    value: "MYLOANCARE VENTURES PRIVATE LIMITED (MONEYWIDE)",
  },
  { label: "SMFG India Credit Co. Ltd", value: "SMFG India Credit Co. Ltd" },
  {
    label: "SMFG India Home Finance Co. Ltd",
    value: "SMFG India Home Finance Co. Ltd",
  },
  { label: "DMI HOUSING FINANCE", value: "DMI HOUSING FINANCE" },
  {
    label: "Fatakpay Digital Private Limited",
    value: "Fatakpay Digital Private Limited",
  },
  {
    label: "LIVLONG PROTECTION & WELLNESS SOLUTIONS LIMITED",
    value: "LIVLONG PROTECTION & WELLNESS SOLUTIONS LIMITED",
  },
  { label: "HDFC LIFE INSURANCE", value: "HDFC LIFE INSURANCE" },
  { label: "CSB Bank Limited", value: "CSB Bank Limited" },
  { label: "Axis Bank Limited ( ASHA)", value: "Axis Bank Limited ( ASHA)" },
  { label: "UTKARSH SMALL FINANCE BANK", value: "UTKARSH SMALL FINANCE BANK" },
  { label: "ARKA FINCAP LIMITED", value: "ARKA FINCAP LIMITED" },
  {
    label: "KRAZYBEE SERVICES PRIVATE LIMITED",
    value: "KRAZYBEE SERVICES PRIVATE LIMITED",
  },
  {
    label: "L&T Finance Holdings Limited",
    value: "L&T Finance Holdings Limited",
  },
  { label: "Sundaram Home Finance Ltd", value: "Sundaram Home Finance Ltd" },
  { label: "MUTHOOT FINANCE LTD", value: "MUTHOOT FINANCE LTD" },
  {
    label: "RULOANS DISTRIBUTION SERVICES PRIVATE LIMITED",
    value: "RULOANS DISTRIBUTION SERVICES PRIVATE LIMITED",
  },
  {
    label: "Incred Financial Services Limited",
    value: "Incred Financial Services Limited",
  },
  {
    label: "Svakarma Finance PrivateLimited",
    value: "Svakarma Finance PrivateLimited",
  },
];

export const COMPANY_TYPE = [
  { label: "Private", value: "private" },
  { label: "Public", value: "public" },
  { label: "Proprietorship", value: "proprietorship" },
];
export const EMPLOYMENT_TYPE = [
  { label: "Business Owner", value: "business_owner" },
  { label: "Salaried Professional", value: "salaried_professional" },
  { label: "Freelancer", value: "freelancer" },
  { label: "Student", value: "student" },
  { label: "Others", value: "others" },
];

export const BALANCE_TRANSFER = [
  { label: "Home Loan", value: "home_loan" },
  { label: "Personal Loan", value: "personal_loan" },
  { label: "Working Capital Loan", value: "working_capital_loan" },
  { label: "Loan Against Property", value: "loan_against_property" },
];
export const INDUSTRY_TYPE = [
  { label: "Agriculture and Farming", value: "Agriculture and Farming" },
  { label: "Manufacturing", value: "Manufacturing" },
  {
    label: "Information Technology (IT)",
    value: "Information Technology (IT)",
  },
  { label: "Services", value: "Services" },
  { label: "Retail", value: "Retail" },
  {
    label: "Real Estate and Construction",
    value: "Real Estate and Construction",
  },
  { label: "Telecommunications", value: "Telecommunications" },
  { label: "Energy and Power", value: "Energy and Power" },
  { label: "Transport and Logistics", value: "Transport and Logistics" },
  { label: "Food and Beverages", value: "Food and Beverages" },
  {
    label: "Healthcare and Pharmaceuticals",
    value: "Healthcare and Pharmaceuticals",
  },
  { label: "Entertainment and Media", value: "Entertainment and Media" },
  { label: "Education and Training", value: "Education and Training" },
  { label: "Tourism", value: "Tourism" },
  { label: "E-commerce", value: "E-commerce" },
  { label: "Textiles and Garments", value: "Textiles and Garments" },
  { label: "Automotive", value: "Automotive" },
  { label: "Banking and Finance", value: "Banking and Finance" },
  {
    label: "Chemicals and Petrochemicals",
    value: "Chemicals and Petrochemicals",
  },
  { label: "Metal and Mining", value: "Metal and Mining" },
  { label: "Renewable Energy", value: "Renewable Energy" },
  { label: "Aerospace and Defense", value: "Aerospace and Defense" },
  { label: "Hospitality", value: "Hospitality" },
  { label: "Printing and Publishing", value: "Printing and Publishing" },
  {
    label: "Nonprofit and Social Enterprises",
    value: "Nonprofit and Social Enterprises",
  },
  { label: "Other", value: "Other" },
];

export const BUSINESS_NATURE_OPTIONS = [
  { label: "Crop Farming", value: "Crop Farming" },
  { label: "Livestock Farming", value: "Livestock Farming" },
  { label: "Organic Farming", value: "Organic Farming" },
  { label: "Agribusiness Consultancy", value: "Agribusiness Consultancy" },
  { label: "Automobile Manufacturing", value: "Automobile Manufacturing" },
  { label: "Electronics Manufacturing", value: "Electronics Manufacturing" },
  { label: "Textile Production", value: "Textile Production" },
  {
    label: "Pharmaceutical Manufacturing",
    value: "Pharmaceutical Manufacturing",
  },
  { label: "Software Development", value: "Software Development" },
  { label: "Web Development", value: "Web Development" },
  { label: "IT Consulting", value: "IT Consulting" },
  { label: "Cloud Services", value: "Cloud Services" },
  {
    label: "Banking and Financial Services",
    value: "Banking and Financial Services",
  },
  { label: "Insurance Services", value: "Insurance Services" },
  { label: "Healthcare Services", value: "Healthcare Services" },
  { label: "Legal Services", value: "Legal Services" },
  { label: "Apparel Retail", value: "Apparel Retail" },
  { label: "Electronics Retail", value: "Electronics Retail" },
  { label: "Grocery Retail", value: "Grocery Retail" },
  { label: "Online Retail", value: "Online Retail" },
  {
    label: "Residential Real Estate Development",
    value: "Residential Real Estate Development",
  },
  { label: "Commercial Construction", value: "Commercial Construction" },
  { label: "Property Management", value: "Property Management" },
  { label: "Architecture and Design", value: "Architecture and Design" },
  { label: "Mobile Network Services", value: "Mobile Network Services" },
  {
    label: "Broadband Internet Services",
    value: "Broadband Internet Services",
  },
  {
    label: "Telecom Infrastructure Development",
    value: "Telecom Infrastructure Development",
  },
  { label: "Electricity Generation", value: "Electricity Generation" },
  { label: "Renewable Energy Projects", value: "Renewable Energy Projects" },
  { label: "Energy Distribution", value: "Energy Distribution" },
  { label: "Freight Transportation", value: "Freight Transportation" },
  {
    label: "Warehousing and Distribution",
    value: "Warehousing and Distribution",
  },
  { label: "Shipping and Logistics", value: "Shipping and Logistics" },
  { label: "Restaurant and Catering", value: "Restaurant and Catering" },
  { label: "Food Processing", value: "Food Processing" },
  { label: "Beverage Manufacturing", value: "Beverage Manufacturing" },
  { label: "Hospitals and Clinics", value: "Hospitals and Clinics" },
  {
    label: "Drug Research and Development",
    value: "Drug Research and Development",
  },
  {
    label: "Pharmaceutical Distribution",
    value: "Pharmaceutical Distribution",
  },
  { label: "Film Production", value: "Film Production" },
  { label: "Television Broadcasting", value: "Television Broadcasting" },
  { label: "Digital Media Services", value: "Digital Media Services" },
  { label: "Schools and Universities", value: "Schools and Universities" },
  { label: "Vocational Training", value: "Vocational Training" },
  { label: "Online Education", value: "Online Education" },
  {
    label: "Hotel and Accommodation Services",
    value: "Hotel and Accommodation Services",
  },
  { label: "Tour Operator", value: "Tour Operator" },
  { label: "Travel Agency", value: "Travel Agency" },
  { label: "Online Retail Marketplace", value: "Online Retail Marketplace" },
  { label: "E-commerce Solutions", value: "E-commerce Solutions" },
  { label: "Online Payment Services", value: "Online Payment Services" },
  { label: "Garment Manufacturing", value: "Garment Manufacturing" },
  { label: "Textile Printing", value: "Textile Printing" },
  { label: "Fabric Retail", value: "Fabric Retail" },
  { label: "Car Dealership", value: "Car Dealership" },
  { label: "Auto Parts Manufacturing", value: "Auto Parts Manufacturing" },
  { label: "Vehicle Repair Services", value: "Vehicle Repair Services" },
  { label: "Retail Banking", value: "Retail Banking" },
  { label: "Investment Banking", value: "Investment Banking" },
  { label: "Financial Advisory", value: "Financial Advisory" },
  { label: "Chemical Manufacturing", value: "Chemical Manufacturing" },
  { label: "Petrochemical Refining", value: "Petrochemical Refining" },
  { label: "Specialty Chemicals", value: "Specialty Chemicals" },
  { label: "Iron and Steel Production", value: "Iron and Steel Production" },
  { label: "Mining Operations", value: "Mining Operations" },
  { label: "Metal Recycling", value: "Metal Recycling" },
  { label: "Solar Power Generation", value: "Solar Power Generation" },
  { label: "Wind Energy Projects", value: "Wind Energy Projects" },
  { label: "Biomass Energy Production", value: "Biomass Energy Production" },
  { label: "Aircraft Manufacturing", value: "Aircraft Manufacturing" },
  {
    label: "Defense Systems Development",
    value: "Defense Systems Development",
  },
  { label: "Aerospace Engineering", value: "Aerospace Engineering" },
  { label: "Hotels and Resorts", value: "Hotels and Resorts" },
  { label: "Restaurant Chains", value: "Restaurant Chains" },
  { label: "Event Management", value: "Event Management" },
  { label: "Print Media Publishing", value: "Print Media Publishing" },
  { label: "Digital Printing Services", value: "Digital Printing Services" },
  { label: "Publishing House", value: "Publishing House" },
  { label: "Education Outreach", value: "Education Outreach" },
  { label: "Healthcare Charities", value: "Healthcare Charities" },
  { label: "Environmental Conservation", value: "Environmental Conservation" },
  { label: "Others", value: "Others" },
];
